export default __webpack_public_path__ + "static/media/ms-pmincho.24be7ffc.woff";